module.exports = "pegasus/assets/blocks/column-15-tech.png";